<template>
  <div>
    <div
      class="text-left text-16 py-10 flex justify-between cursor-pointer"
      v-on="triggers">
      {{ filter.text }}
      <div class="flex items-center text-dark-gray">
        <span class="text-12 pr-6" :class="[isOpen ? 'hidden' : '' ]">More</span>
        <i class="fas" :class="[isOpen ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
      </div>
      
    </div>
    <div class="py-10" v-show="isOpen">
      <filter-checkbox
        v-for="option in filter.options"
        :key="option.value"
        :value="option.value"
        :input="query[option.filter]"
        @input="queryActions.sync({[option.filter]: $event, page: 1})"
        class="mb-12">
        <h3 class="text-14">{{ option.text }}</h3>
        <template v-slot:icon v-if="option.icon">
          <img :src="option.icon" :alt="option.text" class="ml-auto">
        </template>
      </filter-checkbox>
    </div>
  </div>
</template>

<script>
import CustomDisclosure from './CustomDisclosure'
import FilterCheckbox from './FilterCheckbox'

export default {
  extends: CustomDisclosure,

  props: {
    filter: {
      type: Object,
      required: true,
    },
  },

  inject: ['query', 'queryActions'],

  components: {
    FilterCheckbox,
  },
}
</script>
